import { createAction, props } from "@ngrx/store";
import { ServiceError } from "../../create-request/models/shared/ServiceError";
import { Preference } from "../models/Preference";
import { PreferenceTab } from "../models/PreferenceTab";

export const loadPreferences = createAction(
  `[User Preferences] Load Preferences`
);

export const loadPreferencesSuccess = createAction(
  `[User Preferences] Preferences Loaded Successfully`,
  props<{userPreferenceResponse: Preference[]}>()
);

export const loadPreferencesFailure = createAction(
  `[User Preferences] Preferences NOT Loaded`,
  props<ServiceError>()
);

export const savePreferences = createAction(
  `[User Preferences] Save Preferences`,
  props<{userPreferenceRequest: PreferenceTab}>()
);

export const savePreferencesSuccess = createAction(
  `[User Preferences] Preferences Saved Successfully`,
  props<{userPreferenceResponse: Preference[]}>()
);

export const savePreferencesFailure = createAction(
  `[User Preferences] Failed to Save Preferences`,
  props<ServiceError>()
)
